import { KnockOrderType, OrderType } from "../recoil/type";
import Axios, { Response } from "../utils/Axios";
import ApiController from "./ApiController";

export type OrderHistory = {
  order: Order;
};

export type Order = {
  order_id?: string;
  table_area_nr?: number;
  table_nr?: number;
  is_active?: number;
  is_complete?: number;
  completed_at?: null | string;
  child?: OrderChild[];
  store_id?: number;
};

export type OrderChild = {
  order_seq: number;
  order_status: number;
  ordered_at: string;
  payment_type: number;
  payment_status: number;
  bill_number: string;
  order_nr: null | number;
  order_service: number;
  order_type: number;
  total_amount_org: number;
  discount_amount: number;
  tax: number;
  total_amount_incl: number;
  inquiry: string;
  prepared_at: null | string;
  picked_up_at: null | string;
  completed_at: null | string;
  confirmed_at: null | string;
  delivery_expected_at: null | string;
  delivery_completed_at: null | string;
  cancelled_at: null | string;
  cancel_description: null | string;
  detail: OrderProductType[];
  delivery_status?: number;
};

export type Product = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: "";
  product_discount_amount: number;
  product_quantity: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number;
  request_message: string;
  prepared_at: string;
  cancelled_at: string;
  cancel_description: string;
  options: Option[];
  set_options: Product;
};

export type OrderProductType = {
  product_id: number;
  product_seq: number;
  set_product_seq: number;
  product_name: string;
  is_set: number;
  has_option: number;
  product_status: number;
  product_price: number;
  product_discount_name: string;
  product_discount_amount: number;
  product_quantity: number;
  product_tax: number;
  product_tax_name: null | string;
  product_tax_rate: string;
  product_total_amount: number;
  request_id: number | null;
  request_message: string | null;
  prepared_at: string | null;
  cancelled_at: string | null;
  cancel_description: string | null;
  set_prd_type_list: SetPrdType[];
  options: Option[];
};

export type OrderStatusType = {
  store_id: number;
  parent_store_id: number;
  order_id: string;
  order_seq: number;
  order_status: number;
  delivery_estimated_time?: number;
  expected_at?: string;
  cancel_description?: string;
  table_area_nr: number;
  user_token_id: number;
  table_nr: number;
  status_changed_at: string;
};

export type SetPrdType = {
  set_prd_type_id: number;
  set_prd_type_name: string;
  set_prd_type_min: number;
  set_product: SetProduct[];
};

export type SetProduct = {
  product_id: number;
  product_name: string;
  product_price: number;
  product_total_amount: number;
  options: Option[];
};

export type Option = {
  option_id: number;
  option_name: string;
  option_price: number;
};

const OrderController = {
  getAllOrderList: async () => {
    let res = await ApiController.order.getStoreOrder();
    // console.log(JSON.stringify(res));

    let orderList: OrderType[] = [];

    if (res && res.data.length > 0) {
      orderList = res.data;
    }

    return orderList;
  },

  getCompleteOrderList: async () => {
    let res = await ApiController.order.getStoreOrderComplete();
    // console.log(JSON.stringify(res));
    let orderList: OrderType[] = [];

    if (res.ok && res.data.length > 0) {
      orderList = res.data;
    }

    return orderList;
  },

  getNotCompleteOrderList: async () => {
    let res = await ApiController.order.getStoreOrderNotComplete();
    // console.log(JSON.stringify(res));
    let orderList: OrderType[] = [];

    if (res.ok && res.data.length > 0) {
      orderList = res.data;
    }

    return orderList;
  },

  // status 업데이트
  updateStatus: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/order/updateStatus`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문상태 업데이트 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // 배달시간 업데이트
  updateDeliveryInfo: async (
    storeId: number,
    delivery_estimated_time: number
  ): Promise<Response> => {
    try {
      const oParams = {
        store_id: storeId,
        delivery_info: {
          delivery_estimated_time: delivery_estimated_time,
        },
      };
      let sUrl = process.env.REACT_APP_API_URL + `/order/updateDeliveryInfo`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[배달시간 업데이트 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  // 품절 처리
  setSoldout: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/order/setSoldout`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[상품 품절처리 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default OrderController;
